import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";

const apiUrl = "https://api.institucional.global.sidom.io";

export default function Carousel({ images = [] }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const getImageUrl = (item) => {
    return item.url && apiUrl + item.url
      ? apiUrl + item.url
      : item.formats?.large?.url;
  };

  return (
    <div>
      <style>{`
        .swiper {
          width: 100%;
          height: 300px;
          margin-left: auto;
          margin-right: auto;
        }

        .swiper-slide {
          background-size: cover;
          background-position: center;
        }

        .mySwiper2 {
          height: 80%;
          width: 100%;
        }

        .mySwiper {
          height: 10%;
          box-sizing: border-box;
          padding: 10px 0;
        }

        .mySwiper .swiper-slide {
          width: 20%;
          height: 100%;
          opacity: 0.4;
        }

        .mySwiper .swiper-slide-thumb-active {
          opacity: 1;
        }

        .swiper-slide img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}</style>

      {/* Swiper principal */}
      <Swiper
        style={{
          "--swiper-navigation-color": "#ED7850",
          "--swiper-pagination-color": "#ED7850",
        }}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {images.map((item, idx) => (
          <SwiperSlide key={idx}>
            <div className="relative">
              <img
                src={getImageUrl(item)}
                alt={item.alternativeText || item.name || ""}
                className="rounded-3xl h-full w-full object-cover"
              />
              {item.epigrafe && (
                <p className="text-sm text-center text-gray-600 mt-2">
                  {item.epigrafe}
                </p>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Swiper de miniaturas */}
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={Math.min(4, images.length)}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper rounded-xl"
      >
        {images.map((item, idx) => (
          <SwiperSlide key={idx}>
            <img
              src={getImageUrl(item)}
              alt={item.alternativeText || item.name || ""}
              className="rounded-3xl h-full w-full object-cover"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
